import { SchemaType } from '@forms/validation'
import moment from 'moment'

export async function validateAndSubmit(
  schema: SchemaType,
  form,
  setForm,
  submitAction,
  onServerError?: (error: any) => void
): Promise<void> {
  try {
    const values = await schema.validate(form.values, { abortEarly: false })

    const fields = schema.fields
    let parsedValues: Record<string, any> = {}

    Object.keys(fields).forEach(fieldName => {
      if (schema.fields[fieldName].type === 'date') {
        parsedValues[fieldName] = moment(values[fieldName]).format('yyyy-MM-DD')
      } else {
        parsedValues[fieldName] = values[fieldName]
      }
    })

    try {
      await submitAction(parsedValues)
    } catch (serverError) {
      if (onServerError) {
        onServerError(serverError)
        return
      }
      throw serverError
    }
  } catch (formErrors: any) {
    if (formErrors?.inner) {
      let errors = {}

      formErrors.inner.forEach(err => {
        errors[err.path] = err.message
      })

      console.log('Form errors', errors)

      setForm(prevState => ({ ...prevState, errors }))
      return
    }
    throw formErrors
  }
}
